import React, { PropsWithChildren, ReactNode, createContext } from 'react'
import { useQuery } from '@apollo/client'
import { GET_MODULE_ACESS_BY_ROLE, GET_USER_BY_ID } from '../graphql/query'

const RolePermissionContext = createContext<any>({})

interface IProps {
  children?: ReactNode
}

export const RolePermissionProvider: React.FC<PropsWithChildren<IProps>> = ({ children }) => {
  const { loading, error, data } = useQuery(GET_USER_BY_ID)

  const {
    loading: loading2,
    error: error2,
    data: data2
  } = useQuery(GET_MODULE_ACESS_BY_ROLE, {
    variables: {
      input: {
        roleId: data?.getUserById?.UserRole[0]?.roleId
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'AdminPermission'
      }
    },
    skip: !data?.getUserById?.UserRole[0]?.roleId
  })

  if (error || error2) {
    console.log('error in role permission context')
  }
  if (loading || loading2) {
    return <>Loading.</>
  }

  return (
    <RolePermissionContext.Provider
      value={{
        data2
      }}
    >
      {children}
    </RolePermissionContext.Provider>
  )
}

export default RolePermissionContext
